import { checkQuantity } from '../components/update-cart';
import { $Q, $Qll } from './query-selector';

/**
 * Set quantity
 * Set item quantity with custom input,
 * Execute updateCart function
 * @author Cristian Velasco
 */
export const setQuantity = () => {
  return $Qll('.quantity-label').forEach((labelParent) =>
    $Qll('button', labelParent).forEach((btn) => {
      btn.addEventListener('click', updateQuantity);
    })
  );
};

/**
 * Add or subtract input value
 * Ensures the value does not exceed maximum quantity
 * @author Cristian Velasco
 */
function updateQuantity() {
  let input = $Q('input', this.parentElement);
  let variantPrice = $Q('#variantPrice');
  let inputValue = input.getAttribute('min') ? input.getAttribute('min') : 0;
  let pricesToUpdate = $Qll('[data-variant-price]');

  if (this.dataset.action === 'subtr') {
    if (input.value > inputValue) {
      input.value--;
    }
  } else {
    const isOutOfStock = checkQuantity(input);

    // Stop increment if the maximum quantity is reached
    if (isOutOfStock) return;

    const maxQuantity = input.getAttribute('max');
    if (maxQuantity && parseInt(input.value) >= parseInt(maxQuantity)) {
      return; // Prevent increasing beyond the max quantity
    }

    input.value++;
  }

  if (variantPrice) {

  let variantPriceVal = input.value * variantPrice.value;

  if (input.closest('.jc-main-product-quantity')) {
    pricesToUpdate.forEach((priceElem) => {
      priceElem.innerHTML =
        variantPriceVal.toFixed(2) + '€ ' + variantPrice.dataset.currencyHt;
    });
  }
}

  // Trigger a change event to notify listeners
  return input.dispatchEvent(new Event('change'));
}
